/**
 * @generated SignedSource<<431a95069e9a9b208419982ba0b051fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobEventAcceptedExpired_event$data = {
  readonly timestamp: any;
  readonly " $fragmentType": "JobEventAcceptedExpired_event";
};
export type JobEventAcceptedExpired_event$key = {
  readonly " $data"?: JobEventAcceptedExpired_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventAcceptedExpired_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventAcceptedExpired_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node as any).hash = "ebc95a8d1690c31f26786d8aef5375bc";

export default node;
